module.exports = __webpack_public_path__ + "img/docxicon.ec0a1af9.png";